'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CLEARED = 'triggers/CLEARED';
var REMOVED = 'triggers/REMOVED';
var UPDATED = 'triggers/UPDATED';

exports.CLEARED = CLEARED;
exports.REMOVED = REMOVED;
exports.UPDATED = UPDATED;
//# sourceMappingURL=types.js.map
